import Vue from "vue"
/* import productsApi from "../../api/products" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  name: undefined,
  collections: [],
  product_variants: [],
  product_order: undefined,
  tags: [],
  status: undefined,
  indexable: undefined,
  slug: undefined,
  attributes: [],
  key: undefined,
  product: undefined,
  createdAt: undefined,
  updatedAt: undefined
}

const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

const initialState = {
  products: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  products: (state) => state.products,
  productsIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  productsError: (state) => state.error,
  products_Object: (state) => state.object,
  products_isNew: (state) => state.isNew,
  products_selected: (state) => state.selected
}
const actions = {
  async DELETE_products({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("products", object)
    if (apiResponse != null) {
      //commit("PRODUCTS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_products", state.page)
      return true
    } else {
      commit("PRODUCTS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_products({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_products", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_products", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_productsState({ commit }, payload) {
    commit("SET_products", payload)
    return true
  },
  async UPDATE_products({ commit, state, dispatch }, object) {
    let finalObject
    //console.log("ESTO LLEGO", object, state.object.product_variants)
    if (object._id) {
      finalObject = {
        ...object,
        product_variants: state.object.product_variants
          ? state.object.product_variants.map((variant) => {
              return variant._id
            })
          : []
      }
      //console.log("ESTO LLEGO OBJ LLENO", finalObject)
    } else {
      finalObject = {
        ...state.object,
        product_variants: state.object.product_variants
          ? state.object.product_variants.map((variant) => {
              return variant._id
            })
          : []
      }
      //console.log("ESTO LLEGO OBJ VACIO", finalObject)
    }

    const filtered = Object.keys(finalObject)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = finalObject[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("products", filtered)
    if (apiResponse != null) {
      commit("PRODUCTS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_products", state.page)
      return true
    } else {
      commit("PRODUCTS_ERROR")
      return false
    }
  },
  async CREATE_products({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("products", object)
    //console.log("CREATING PRODUCT", apiResponse)
    if (apiResponse != null) {
      commit("SET_products", {
        param: "object",
        value: apiResponse.product
      })
      dispatch("FETCH_PAGE_products", state.page)
      return true
    } else {
      commit("PRODUCTS_ERROR")
      return false
    }
  },
  async FETCH_products({ commit }) {
    let apiResponse = await utilsApi.getObjects("products")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRODUCTS_SETTING", apiResponse)
      return true
    } else {
      commit("PRODUCTS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_products({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("products", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PRODUCTS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("PRODUCTS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_products({ commit }, payload) {
    //console.log("UPDATE OBJECT PRODUCTS", payload)
    commit("SET_OBJECT_PRODUCT", payload)
    //commit("SET_OBJECT_VARIATION", payload.product_variants[0])
    return true
  },
  UPDATE_OBJECT_VARIATION_products({ commit, getters }, payload) {
    let oldVariation = getters.products_Object.product_variants.findIndex(
      (option) => option._id == payload._id
    )
    let finalObject = { ...getters.products_Object }

    finalObject.product_variants[oldVariation] = payload

    commit("SET_OBJECT_PRODUCT", finalObject)
    return true
  },
  UPDATE_IS_NEW_products({ commit }, payload) {
    commit("SET_IS_NEW_PRODUCT", payload)
    commit("SET_OBJECT_PRODUCT_INITIAL")
    return true
  },
  CLEAN_OBJECT_products({ commit }) {
    commit("SET_OBJECT_PRODUCT_INITIAL")
    return true
  },
  async CLEAN_STORE_products({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_products", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_products({ commit }, payload) {
    commit("SET_SELECTED_PRODUCTS", payload)
    return true
  },
  REMOVE_VARIATION_products({ commit, dispatch, state }, payload) {
    commit("REMOVE_VARIATION", payload)

    //console.log("VARIATIONS REMOVIN", state.object)
    dispatch("UPDATE_OBJECT_product_variants", state.object.product_variants[0])
    return true
  }
}
const mutations = {
  PRODUCTS_SETTING: (state, { products, count = false, page }) => {
    state.count = count || state.products.length

    state.page = page || state.page
    state.products = products
    state.fetched = true
    state.error = false
  },
  PRODUCTS_ERROR: (state) => {
    state.products = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_PRODUCT: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  ADD_VARIATION_NEW: (state, variant) => {
    state.object.product_variants.push(variant)
    /* = Object.assign({}, state.object, )  */
  },
  REMOVE_VARIATION: (state, variant) => {
    state.object.product_variants = state.object.product_variants.filter(
      (product_variant) => {
        return product_variant._id !== variant._id
      }
    )

    /* = Object.assign({}, state.object, )  */
  },
  SET_OBJECT_PRODUCT_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_IS_NEW_PRODUCT: (state, payload) => {
    state.isNew = payload
  },
  SET_SELECTED_PRODUCTS: (state, selectedProducts) => {
    state.selected = selectedProducts
  },
  SET_products: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
